import { Fragment } from 'react';
import { useSuspenseQuery } from '@apollo/client/react';

import { ProfileDocument } from 'src/graphql/actions/profile/profile.query';
import { withSuspense } from 'src/hoc';
import { TOTPContextProvider, TOTPDialogContainer } from 'src/containers/TOTP';
import { useAuth } from 'src/context/auth/use-auth';

import { BasicCard, AccessDetailsCard, TOTPCard } from './ui';

const ProfileContainer = () => {
  const {
    data: { profile },
  } = useSuspenseQuery(ProfileDocument);
  const { isExternalUser } = useAuth();

  return (
    <Fragment>
      <BasicCard name={profile?.name || ''} phone={profile?.phone || ''} />
      {!isExternalUser && (
        <>
          <AccessDetailsCard email={profile?.email || ''} />
          <TOTPContextProvider>
            <TOTPCard />
            <TOTPDialogContainer />
          </TOTPContextProvider>
        </>
      )}
    </Fragment>
  );
};

export default withSuspense(ProfileContainer);
